/**
 * defaultKeyRemaps — Documented default action→key stub (SPY-42).
 * Pure: no DOM. Future settings UI can overlay custom remaps.
 */

export const DEFAULT_KEY_REMAPS = Object.freeze({
  abilityQ: 'q',
  abilityW: 'w',
  abilityE: 'e',
  abilityR: 'r',
  summonerD: 'd',
  summonerF: 'f',
  shop: 'p',
  scoreboard: 'Tab',
  attackMove: 'a'
});

/**
 * @returns {{ action: string, key: string }[]}
 */
export function listDefaultKeyRemaps() {
  return Object.entries(DEFAULT_KEY_REMAPS).map(([action, key]) => ({
    action,
    key
  }));
}

/**
 * @param {string} action
 * @param {Record<string, string>} [remaps]
 * @returns {string|null}
 */
export function resolveRemappedKey(action, remaps = DEFAULT_KEY_REMAPS) {
  if (!action || !remaps || typeof remaps !== 'object') return null;
  const key = remaps[action];
  if (key === undefined || key === null) return null;
  return String(key);
}

/**
 * Normalize a pressed or bound key for equality checks (SPY-113).
 * @param {string|null|undefined} key
 * @returns {string}
 */
export function normalizeBindKey(key) {
  if (key === undefined || key === null) return '';
  return String(key).toLowerCase();
}

/**
 * @param {string} pressedKey
 * @param {string} action
 * @param {Record<string, string>} [remaps]
 * @returns {boolean}
 */
export function keyMatchesAction(pressedKey, action, remaps = DEFAULT_KEY_REMAPS) {
  const expected = resolveRemappedKey(action, remaps);
  if (!expected) return false;
  return normalizeBindKey(pressedKey) === normalizeBindKey(expected);
}
